import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseService } from '../../services/base.service';
import { Http } from '@angular/http';
import { ISeasonWeek } from '../../models/ISeasonWeek';
import { AdminService } from '../../services/admin.service';
import { NflService } from '../../services/nfl.service';
import { IOrg } from '../../models/IOrg';
import { FormBuilder, FormGroup } from '@angular/forms'
import { AuthService } from '../../account/auth.service';
import { IGame } from '../../models/IGame';
import { Subscription } from 'rxjs';
import { OrgSeasonWeekService } from '../../services/orgseasonweek.service';
import { IOrgSeasonWeek } from '../../models/IOrgSeasonWeek';

@Component({
  selector: 'app-spread-manager',
  templateUrl: './spread-manager.component.html',
  styleUrls: ['./spread-manager.component.scss']
})
export class SpreadManagerComponent implements OnInit {

  public isRequesting: boolean = false;
  public model: IOrgSeasonWeek = { season: null, seasonType: null, week: null, org: null };
  public games: IGame[];
  public orgs: IOrg[];
  public selectedOrg: IOrg;
  public seasonWeeks: ISeasonWeek[] = []
  public isHomeFavorite: boolean;

  public disabled: boolean = false;
  public localTime: string;
  public serverStartDateTime: Date;
  public error: any;

  constructor(
    private orgSeasonWeekService: OrgSeasonWeekService,
    private nflService: NflService,
    private baseService: BaseService) {
  }
  public orgEvent: Subscription;
  public weekEvent: Subscription;
  public seasonEvent: Subscription;

  ngOnInit() {
    this.orgEvent = this.orgSeasonWeekService.org.subscribe(org => {
      this.model.org = org;
      this.weekEvent = this.orgSeasonWeekService.season.subscribe(season => {
        this.model.season = season;
        this.seasonEvent = this.orgSeasonWeekService.week.subscribe(week => {
          this.model.week = week;
          this.nflService.getOrgGames(this.model).subscribe(orgGames => {
            if (orgGames.length == 0) {
              this.nflService.createOrgGamesWithOdds(this.model).subscribe(orgGamesWithOdds => {
                this.games = orgGamesWithOdds as IGame[];
                this.games.sort((a, b) => this.baseService.getEpochTime(a.startDateTime) - this.baseService.getEpochTime(b.startDateTime));
              });
            }
            else {
              this.games = orgGames as IGame[];
              this.games.sort((a, b) => this.baseService.getEpochTime(a.startDateTime) - this.baseService.getEpochTime(b.startDateTime));
            }
            
          });
        });
      });
    });


  }

  ngOnDestroy(): void {
    this.orgEvent.unsubscribe();
    this.seasonEvent.unsubscribe();
    this.weekEvent.unsubscribe();
  }


  // create() {
  //   this.isRequesting = true;
  //   if (this.form.valid) {
  //     this.adminService.createNflSeasonWeek(this.model).subscribe(response => {
  //       console.log(response);
  //       this.isRequesting = false;
  //     })
  //   }
  //   this.isRequesting = false;

  // }

  // createOrgGame() {
  //   this.isRequesting = true;
  //   if (this.selectedOrg && this.form.valid) {
  //     this.adminService.createOrgGames(this.model, this.selectedOrg).subscribe(response => {
  //       this.isRequesting = false;
  //     })

  //   }
  // }

  changeHomeToFavorite(game: IGame) {
    game.favorite = game.home;
    game.underdog = game.away;
    this.updateOrgGame(game);
    this.baseService.toasterService.pop('info', 'Spread Manager', 'Favorite changed to ' + game.favorite.name);
  }

  changeAwayToFavorite(game: IGame) {
    game.favorite = game.away;
    game.underdog = game.home;
    this.updateOrgGame(game);
    this.baseService.toasterService.pop('info', 'Spread Manager', 'Favorite changed to ' + game.favorite.name);
  }
  settCurrentOrg(org: IOrg) {
    this.selectedOrg = org;
  }

  changeSpread(game: IGame) {
    this.updateOrgGame(game);
    this.baseService.toasterService.pop('info', 'Spread Manager', 'Spread changed to ' + game.spread);
  }


  updateOrgGame(game: IGame) {
    // game.orgId = this.selectedOrg.id;
    this.nflService.updateOrgGame(game);
    //this.nflService.updateOrgGame(game).compl
  }

  localtime(gamestart: any) {
    return this.baseService.getLocalTimeFromUtc(gamestart);
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/nflmanager/spread-manager/spread-manager.component.ts